import { faPlus, faSync, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";

import {
  Card,
  CardBody,
  CardHeader,
  Container,
  Button,
  ListGroup,
  ListGroupItem,
} from "reactstrap";

import AddNotificationEmailModal from "../../components/admin/AddNotificationEmailModal";
import { notificationApi } from "../../services/notificationServices";
import ConfirmationModal from "../../components/ConfirmationModal";
import InformationModal from "../../components/InformationModal";
import Loader from "../../components/Loader";

const InvoicingEmailNotifications = () => {
  const [loading, setLoading] = useState(true);
  const [emailNotifications, setEmailNotifications] = useState([]);
  const [refresh, setRefresh] = useState();
  const [addModal, setAddModal] = useState();

  const initConfirmationModal = {
    isOpen: false,
    onSubmit: null,
    onClose: null,
    title: "",
    body: "",
  };

  const [confirmationModal, setConfirmationModal] = useState(
    initConfirmationModal
  );

  const [informationModal, setInformationModal] = useState({
    isOpen: false,
    title: "",
    body: "",
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const result = await notificationApi.getInvoicingEmailNotifications({
          pageSize: 9999,
        });
        setEmailNotifications(result.data);
        setLoading(false);
      } catch (err) {
        setLoading(false);
      }
    };
    fetchData();
  }, [refresh]);

  const removeEmail = (index) => {
    const emailNotification = emailNotifications[index];
    setConfirmationModal({
      isOpen: true,
      confirmColor: "danger",
      onSubmit: async () => {
        try {
          setLoading(true);
          const updatedEmailNotifications = [...emailNotifications];
          updatedEmailNotifications.splice(index, 1);
          await notificationApi.updateInvoicingEmailNotifications({
            items: updatedEmailNotifications,
          });
          setEmailNotifications(updatedEmailNotifications);
          setLoading(false);
          setConfirmationModal(initConfirmationModal);
          setInformationModal({
            isOpen: true,
            title: "Remove Email Notification",
            body: "Email removed successfully.",
          });
        } catch (err) {
          setConfirmationModal(initConfirmationModal);
          setLoading(false);
        }
      },
      onClose: () => {
        setConfirmationModal(initConfirmationModal);
      },
      title: "Remove Email Notification",
      body: `<span class="text-center">Do you confirm you want to remove ${emailNotification.email}?</span>`,
    });
  };

  return (
    <Container fluid className="flex-grow-1 flex-column d-flex">
      <Card>
        <CardHeader className="d-flex align-items-center justify-content-between mt-2">
          <div className="text-dark flex-grow-1 d-flex align-items-center">
            <h3 className="mb-0 ">Invoicing Email Notifications</h3>
          </div>
          <div className="d-flex align-items-center justify-content-between">
            <Button
              size="sm"
              className="mr-3 rounded-circle d-flex custom-rounded-button"
              color="primary"
              onClick={() => setRefresh(!refresh)}
            >
              <FontAwesomeIcon icon={faSync} />
            </Button>
            <Button
              size="sm"
              className="rounded-circle d-flex custom-rounded-button"
              color="primary"
              onClick={() => setAddModal(true)}
            >
              <FontAwesomeIcon icon={faPlus} />
            </Button>
          </div>
        </CardHeader>
        <CardBody>
          {loading ? (
            <Loader />
          ) : emailNotifications.length ? (
            <ListGroup flush className="border-top">
              <ListGroupItem
                className="py-2 border-bottom font-weight-bold bg-lighter text-muted small d-flex justify-content-between"
                tag="div"
              >
                <div className="col-5">Email</div>
                <div className="col-5">Type</div>
                <div className="col-2"></div>
              </ListGroupItem>
              {emailNotifications.map((emailNotification, index) => (
                <ListGroupItem
                  key={index}
                  className="py-2 border-bottom d-flex justify-content-between align-items-center"
                  tag="div"
                >
                  <div className="col-5">{emailNotification.email}</div>
                  <div className="col-5">{emailNotification.type}</div>
                  <div className="col-2 d-flex justify-content-end">
                    <Button
                      className="ml-2 rounded d-flex align-items-center"
                      color="none"
                      size="sm"
                      onClick={() => removeEmail(index)}
                    >
                      <FontAwesomeIcon
                        icon={faTrash}
                        className="text-danger"
                        size="lg"
                      />
                    </Button>
                  </div>
                </ListGroupItem>
              ))}
            </ListGroup>
          ) : (
            <div className="text-center">No emails added</div>
          )}
        </CardBody>
      </Card>
      {addModal ? (
        <AddNotificationEmailModal
          submitFunction={notificationApi.createInvoicingEmailNotification}
          onSubmit={() => {
            setAddModal();
            setInformationModal({
              isOpen: true,
              title: "Add Email Notification",
              body: "Email added successfully.",
            });
            setRefresh(!refresh);
          }}
          onClose={() => setAddModal()}
        />
      ) : confirmationModal.isOpen ? (
        <ConfirmationModal {...confirmationModal} />
      ) : informationModal.isOpen ? (
        <InformationModal
          title={informationModal.title}
          body={informationModal.body}
          onClose={() =>
            informationModal.onClose
              ? informationModal.onClose()
              : setInformationModal({ isOpen: false, title: "", body: "" })
          }
        />
      ) : null}
    </Container>
  );
};

export default InvoicingEmailNotifications;
